import { createSlice } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
const initialKybFormData = {
  firstName: null,
  lastName: null,
  birthdate: null,
  address: null,
  ubos: null,
  isLegalRepresentativeUbo: true,
  documents: [],
  identityDocumentExpiryDate: ''
};
export const initialState = {
  registration: {
    businessRepresentative: {
      fullName: '',
      firstNames: '',
      lastName: '',
      birthday: '',
      nationality: {
        code: '',
        title: ''
      },
      country: {
        code: '',
        title: ''
      }
    },
    businessDetails: {
      legalCode: '',
      legalName: '',
      entityType: '',
      registrarName: '',
      vat: '',
      isVatDisabled: false
    },
    addresses: {
      businessAddress: {
        postalCode: '',
        fullPostalCode: '',
        city: '',
        countryId: null,
        line1: '',
        line2: ''
      },
      legalRepresentativeAddress: {
        postalCode: '',
        fullPostalCode: '',
        city: '',
        countryId: null,
        line1: '',
        line2: ''
      },
      isSameLegalRepresentativeAddress: true,
      isBusinessEqualToPersonalAddress: false
    },
    profile: {
      photoTempUuid: '',
      photoUrl: undefined,
      businessAccountName: '',
      phoneNumber: '',
      isPhoneNumberPersonal: false,
      email: '',
      isEmailPersonal: false
    }
  },
  uiState: UiState.Idle,
  legalEntityUiState: UiState.Idle,
  errors: [],
  showGeneralError: false,
  entityType: '',
  paymentsIdentityConfiguration: null,
  kybFormData: initialKybFormData
};

const storeRegistration = (draft, action) => {
  Object.keys(action.payload).forEach(key => {
    draft.registration[key] = cloneDeep(action.payload[key]);
  });
};

const clearRegistration = draft => {
  draft.registration = initialState.registration;
};

const setUiState = (draft, action) => {
  draft.uiState = action.payload;
};

const setEntityType = (draft, action) => {
  draft.entityType = action.payload.entityType;
};

const setErrors = (draft, action) => {
  draft.errors = action.payload;
};

const clearErrors = draft => {
  draft.errors = [];
  draft.showGeneralError = false;
};

const setInitialValuesFromUserDto = (draft, action) => {
  const {
    real_name,
    birthday,
    photo
  } = action.payload;

  if (real_name && !draft.registration.businessRepresentative.fullName) {
    draft.registration.businessRepresentative.fullName = real_name;
  }

  if (birthday && !draft.registration.businessRepresentative.birthday) {
    draft.registration.businessRepresentative.birthday = birthday;
  }

  if (photo !== null && photo !== void 0 && photo.url && !draft.registration.profile.photoUrl) {
    draft.registration.profile.photoUrl = photo.url;
  }
};

const setLegalCode = (draft, action) => {
  draft.registration.businessDetails.legalCode = action.payload.legalCode;
};

const setLegalEntity = (draft, action) => {
  draft.registration.businessDetails.entityType = action.payload.typeLabel;
  draft.registration.businessDetails.legalName = action.payload.name;
  draft.registration.addresses.businessAddress.postalCode = action.payload.postalCode;
  draft.registration.addresses.businessAddress.line1 = action.payload.streetAddressLine1;
  draft.registration.addresses.businessAddress.line2 = action.payload.streetAddressLine2;
};

const setLegalEntityUiState = (draft, action) => {
  draft.legalEntityUiState = action.payload;
};

const setShowGeneralError = draft => {
  draft.showGeneralError = true;
};

const setConfiguration = (draft, action) => {
  const {
    configuration
  } = action.payload;
  draft.paymentsIdentityConfiguration = configuration;
  draft.kybFormData = {
    firstName: configuration.firstName,
    lastName: configuration.lastName,
    birthdate: configuration.birthdate,
    address: configuration.address,
    ubos: null,
    isLegalRepresentativeUbo: draft.kybFormData.isLegalRepresentativeUbo,
    documents: [],
    identityDocumentExpiryDate: draft.kybFormData.identityDocumentExpiryDate
  };
};

const setKybFormData = (draft, action) => {
  const {
    ubos,
    documents
  } = action.payload;
  draft.kybFormData.firstName = draft.registration.businessRepresentative.firstNames || '';
  draft.kybFormData.lastName = draft.registration.businessRepresentative.lastName || '';
  draft.kybFormData.birthdate = draft.registration.businessRepresentative.birthday || '';
  draft.kybFormData.address = draft.registration.addresses.businessAddress || null;
  draft.kybFormData.ubos = ubos;
  draft.kybFormData.documents = documents;
};

const setIsLegalRepresentativeUbo = (draft, action) => {
  const {
    isLegalRepresentativeUbo
  } = action.payload;
  draft.kybFormData.isLegalRepresentativeUbo = isLegalRepresentativeUbo;
};

const businessAccountsSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    storeRegistration,
    clearRegistration,
    setUiState,
    setEntityType,
    setErrors,
    clearErrors,
    setLegalCode,
    setLegalEntity,
    setLegalEntityUiState,
    setShowGeneralError,
    setInitialValuesFromUserDto,
    setConfiguration,
    setKybFormData,
    setIsLegalRepresentativeUbo
  }
});
export const {
  actions
} = businessAccountsSlice;
export const plug = {
  [stateName]: businessAccountsSlice.reducer
};
export default businessAccountsSlice.reducer;